<div class="modal-container" [style.width.%]="modalWidth">
    <div *ngIf="tabType === 'key_person_tab'">
        <div class="modal-header">
          <h2>Add Individual</h2>
          <button class="pt-0" mat-icon-button (click)="close()">
              <mat-icon>close</mat-icon>
          </button>
        </div>

        <form [formGroup]="form" (ngSubmit)="addIndividualDetails()" style="margin-bottom: 60px;">
          <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>

          <button class="blue_button float-end ms-3 me-3" mat-raised-button type="submit" >Submit</button>
          <button class="float-end" mat-stroked-button color="secondary" (click)="close()">Close</button>
        </form>
    </div>

    <div *ngIf="tabType === 'document_tab'">
        <div class="modal-header">
          <h2 *ngIf="isApplicable">Add Document</h2>
          <h2 *ngIf="!isApplicable">Not Applicable</h2>
          <button class="pt-0" mat-icon-button (click)="close()">
              <mat-icon>close</mat-icon>
          </button>
        </div>
        <form [formGroup]="docForm" class="mt-4">
            <div class="row" *ngIf="isApplicable">
              <div class="col-md-12">
                  <div class="form-group">
                   <mat-radio-group
                      formControlName="appDoc"
                      class="radio-group mt-4"
                      style="display: flex; gap: 15px;"
                    >
                      <mat-radio-button value="upload_from_device">
                        Upload from Your Device
                      </mat-radio-button>

                      <mat-radio-button value="upload_from_mobile">
                        Take Photo
                      </mat-radio-button>
                    </mat-radio-group>

                    <!-- <div class="radio-group mt-4" style="display: flex; gap: 15px;">
                      <label class="radio-label text-dark">
                        <input type="radio" formControlName="appDoc" value="upload_from_device" required checked>
                        Upload from Your Device
                      </label>
                      <label class="radio-label text-dark">
                        <input type="radio" formControlName="appDoc" value="upload_from_mobile" required>
                        Take Photo
                      </label>
                    </div> -->
                    <div *ngIf="docForm.get('appDoc')?.invalid" class="text-danger">
                      Please select an option.
                    </div>
                  </div>

<!--                  <div class="form-group mt-4" *ngIf="docForm.get('appDoc')?.value === 'upload_from_device'">-->
<!--                       <input-->
<!--                         matInput-->
<!--                         type="file"-->
<!--                         #attachInput-->
<!--                         id="fileUpload"-->
<!--                         [attr.placeholder]="docForm.get('uploadDocuments')?.placeholder"-->
<!--                         accept=".pdf,.doc,.docx,.jpg,.png,.xlsx,.csv,.txt,.jpeg,.heic"-->
<!--                         multiple-->
<!--                         class="form-control"-->
<!--                         (change)="onFileSelected($event)"-->
<!--                       />-->
<!--                    <small class="form-text text-muted">-->
<!--                      * Supported document types are pdf, doc, docx, jpg, png, xlsx, csv, txt, jpeg, heic-->
<!--                    </small> <br>-->
<!--                    <small class="form-text text-muted">-->
<!--                      {{supportMaxFileSize}}-->
<!--                    </small>-->

<!--                    <div *ngIf="docForm.get('uploadDocuments')?.hasError('required') && formSubmitted">-->
<!--                      <span class="text-danger">Select a file.</span>-->
<!--                    </div>-->
<!--                    <div class="selected-files" *ngIf="AttachFiles.length > 0">-->
<!--                      <p class="file-count">{{ AttachFiles.length }} of {{ max_file_count }} files selected</p>-->
<!--                      <ul class="file-list">-->
<!--                        <li *ngFor="let name of attachNames; let i = index" class="file-item">-->
<!--                          <span class="file-name" [title]="name">{{ name }}</span>-->
<!--                          <button type="button" class="remove-btn" (click)="removeFile(i)">✕</button>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->


                <div class="form-group mt-4" *ngIf="docForm.get('appDoc')?.value === 'upload_from_device'">
                  <input
                    matInput
                    type="file"
                    #attachInput
                    id="fileUpload"
                    [attr.placeholder]="docForm.get('uploadDocuments')?.placeholder"
                    accept=".pdf,.doc,.docx,.jpg,.png,.xlsx,.csv,.txt,.jpeg,.heic"
                    multiple
                    [disabled]="isUploading"
                    class="form-control"
                    (change)="onFileSelected($event)"
                  />
                  <small class="form-text text-muted">
                    * Supported document types are pdf, doc, docx, jpg, png, xlsx, csv, txt, jpeg, heic
                  </small> <br>
                  <small class="form-text text-muted">
                    {{ supportMaxFileSize }}
                  </small>

                  <div *ngIf="docForm.get('uploadDocuments')?.hasError('required') && formSubmitted">
                    <span class="text-danger">Select a file.</span>
                  </div>

                  <div class="upload-panel" *ngIf="fileItems.length > 0">
                    <div class="overall-progress-header">
      <span class="overall-label">
        <ng-container *ngIf="isUploading">Uploading {{ uploadedCount }} of {{ fileItems.length }}…</ng-container>
        <ng-container *ngIf="!isUploading">{{ fileItems.length }} of {{ max_file_count }} files selected</ng-container>
      </span>
                      <span class="overall-percent" *ngIf="isUploading">{{ overallProgress }}%</span>
                    </div>
                    <div class="overall-progress-track" *ngIf="isUploading">
                      <div class="overall-progress-fill" [style.width.%]="overallProgress"></div>
                    </div>

                    <ul class="file-list">
<!--                      <li *ngFor="let item of fileItems" class="file-item" [ngClass]="'status-' + item.status">-->
<!--                        <div class="file-icon">-->
<!--                          <svg viewBox="0 0 24 24"><path d="M6 2h9l5 5v15H6z" fill="#8ea6c9"/><path d="M15 2v5h5" fill="#5c7ba3"/></svg>-->
<!--                        </div>-->

<!--                        <div class="file-info">-->
<!--                          <div class="file-name" [title]="item.name">{{ item.name }}</div>-->

<!--                          <div class="file-progress-track" *ngIf="item.status === 'uploading'">-->
<!--                            <div class="file-progress-fill" [style.width.%]="item.progress"></div>-->
<!--                          </div>-->

<!--                          <div class="file-error" *ngIf="item.status === 'failed'">{{ item.errorMessage }}</div>-->
<!--                        </div>-->

<!--                        <div class="file-status">-->
<!--                          <ng-container [ngSwitch]="item.status">-->
<!--                            <div *ngSwitchCase="'pending'" class="status-pending"></div>-->
<!--                            <div *ngSwitchCase="'uploading'" class="spinner"></div>-->

<!--                            <svg *ngSwitchCase="'success'" class="icon-success" viewBox="0 0 24 24">-->
<!--                              <circle cx="12" cy="12" r="11" fill="#1e8e3e"/>-->
<!--                              <path d="M7 12.5l3 3 7-7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                            </svg>-->

<!--                            <svg *ngSwitchCase="'failed'" class="icon-error" viewBox="0 0 24 24">-->
<!--                              <circle cx="12" cy="12" r="11" fill="#d93025"/>-->
<!--                              <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>-->
<!--                              <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>-->
<!--                            </svg>-->
<!--                          </ng-container>-->

<!--                          <button type="button" class="icon-btn retry-btn" *ngIf="item.status === 'failed'" (click)="retryFile(item.id)" title="Retry upload">-->
<!--                            <svg viewBox="0 0 22 22"><path d="M17.65 6.35A8 8 0 1 0 19.5 13h-2.1a6 6 0 1 1-1.4-5.65L13 10h7V3z" fill="#5f6368"/></svg>-->
<!--                          </button>-->

<!--                          <button type="button" class="icon-btn remove-btn pt-1" *ngIf="item.status !== 'uploading'" (click)="removeFile(item.id)" title="Remove file">✕</button>-->
<!--                        </div>-->
<!--                      </li>-->
                      <li *ngFor="let item of fileItems" class="file-item" [ngClass]="'status-' + item.status">
                        <div class="file-icon" [ngClass]="getFileTypeMeta(item.name).className">
                          {{ getFileTypeMeta(item.name).label }}
                        </div>

                        <div class="file-info">
                          <div class="file-name" [title]="item.name">{{ item.name }}</div>
                          <div class="file-meta">
                            <span class="file-size">{{ formatFileSize(item.size) }}</span>
                            <span class="file-size-warning" *ngIf="item.sizeError">{{ item.sizeError }}</span>

                            <div class="file-progress-track" *ngIf="item.status === 'uploading'">
                              <div class="file-progress-fill" [style.width.%]="item.progress"></div>
                            </div>
                          </div>

<!--                          <div class="file-error" *ngIf="item.status === 'failed'">{{ item.errorMessage }}</div>-->
                        </div>

                        <div class="file-status">
                          <ng-container [ngSwitch]="item.status">
                            <div *ngSwitchCase="'pending'" class="status-pending"></div>
                            <div *ngSwitchCase="'uploading'" class="spinner"></div>

                            <svg *ngSwitchCase="'success'" class="icon-success" viewBox="0 0 24 24">
                              <circle cx="12" cy="12" r="11" fill="#1e8e3e"/>
                              <path d="M7 12.5l3 3 7-7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            <svg *ngSwitchCase="'failed'" class="icon-error" viewBox="0 0 24 24">
                              <circle cx="12" cy="12" r="11" fill="#d93025"/>
                              <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                              <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                          </ng-container>

                          <button type="button" class="icon-btn retry-btn" *ngIf="item.status === 'failed'" (click)="retryFile(item.id)" title="Retry upload">
                            <svg viewBox="0 0 24 24"><path d="M17.65 6.35A8 8 0 1 0 19.5 13h-2.1a6 6 0 1 1-1.4-5.65L13 10h7V3z" fill="#5f6368"/></svg>
                          </button>

                          <button type="button" class="icon-btn remove-btn" *ngIf="item.status !== 'uploading' && item.status !== 'success'" (click)="removeFile(item.id)" title="Remove file">✕</button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                  <div class="form-group mt-4" *ngIf="docForm.get('appDoc')?.value === 'upload_from_mobile'">
                    <img *ngIf="capturedPhotoFromModal" [src]="capturedPhotoFromModal"
                          class="thumbnail-image"/>
                    <button class="blue_button mt-4" mat-raised-button type="submit" (click)="openPopUpForCaptureImg()">Take Photo</button>
                  </div>

              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12 mt-4">
                <div class="custom-textarea-wrapper">
                  <label for="comments" *ngIf="!isApplicable">Comments*</label>
                  <label for="comments" *ngIf="isApplicable">Comments</label>
                  <textarea
                    id="comments"
                    formControlName="comments"
                    rows="5"
                    required
                    class="border-radius"
                  ></textarea>
                  <div *ngIf="!isApplicable">
                    <div *ngIf="docForm.get('comments')?.hasError('required')">
                      <span class="text-danger">Comments are required.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <!-- <input type="file" formControlName="appDoc" #fileInput (change)="onFileSelected($event)" multiple> -->
          <!-- <formly-form [model]="uploadDocmodel" [fields]="uploadDocfields" [form]="uploadDocform"></formly-form> -->
           <button class="float-end" mat-stroked-button color="secondary" (click)="close()" >Close</button>
           <!-- upload doc -->
            <button *ngIf="isApplicable" class="blue_button float-end me-3" mat-raised-button type="submit" (click)="uploadAppDoc()">Submit</button>
            <!-- not Applicable -->
            <button *ngIf="!isApplicable" class="blue_button float-end me-3" mat-raised-button type="submit" (click)="uploadNotAppDoc()">Submit</button>

        </form>

    </div>

    <div *ngIf="tabType === 'lic_tab'">

      <div class="modal-header">
        <h2>Add License</h2>
        <button class="pt-0" mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-card>

        <form [formGroup]='searchinput' class="px-4 mt-4">
          <div class="comply row mt-4">
              <div class="col-sm-10 col-xs-12 col-lg-10 col-md-10">
                  <mat-form-field class=" w-100">
                    <mat-label>License</mat-label>
                      <input matInput formControlName='search_field'>
                      <mat-error>Maximum 100 Characters Allowed </mat-error>
                  </mat-form-field>
                  <div class="close-btn right-3" *ngIf="searchinput.value.search_field"
                      (click)="searchinput.patchValue({search_field :''});filterValidation(0)">
                  </div>
              </div>
              <div class="col-sm-2 col-xs-12 col-lg-2 col-md-2 mb-3">
                  <button class="blue_button float-end" style="margin-top: 3px !important;" mat-raised-button (click)="filterValidation(1)">Search</button>
              </div>

          </div>
      </form>
        <div class="checkBoxlign">
      <div class="table-responsive striped users_mod limit_height">
          <table class="col-12 multi_header_table  scrollling_table"
              (matSortChange)="sortData($event)" mat-table matSort [dataSource]="license_data">
              <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="bp_license_status_name" class="w120-container date-width">
                      Status
                  </th>
                  <td mat-cell *matCellDef="let element">{{element?.bp_license_status_name}}</td>
              </ng-container>

              <ng-container matColumnDef="Business Legal Name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="business_legal_name"> Business Legal Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element?.business_legal_name}}</td>
              </ng-container>

              <ng-container matColumnDef="License Type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="bp_license_type_name"> License Type
                </th>
                <td mat-cell *matCellDef="let element"> {{element?.bp_license_type_name}}</td>
            </ng-container>

            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef> Action</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox (change)="onCheckboxChange(element, $event)"></mat-checkbox>
                <!-- <input type="checkbox" (change)="onCheckboxChange(element, $event)"> -->
                <!-- {{element?.bp_license_type_name}} -->
              </td>
          </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
      </div>
      <div class="col-12 text-center" *ngIf="license_data?.length == 0">
          <span class="NoDataFound">
              No Data Found
          </span>
      </div>
      <div class="col-12 bgWhite">
          <div class="row align-items-center ">
              <div class="col-12">
                  <mat-paginator *ngIf="license_data?.length != 0"
                      [pageSizeOptions]="page.pageSizeOptions" [length]="page.limit"
                      [pageSize]="page.pageSize" (page)="PageChange($event)" [pageIndex]="page.index"
                      showFirstLastButtons></mat-paginator>
              </div>
          </div>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 mb-4">
        <button class="blue_button mb-4 float-end me-4" mat-raised-button (click)="submitSelectedRow()">Submit</button>
      </div>

  </div>
      </mat-card>
  </div>


    </div>
